import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TableSearch } from '@shared/types/table';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'rav-basic-search',
  templateUrl: './basic-search.component.html',
  styleUrls: ['./basic-search.component.scss']
})
export class BasicSearchComponent implements AfterViewInit {
  @Input() searchLabel: string;
  @Output() newBasicSearch = new EventEmitter<TableSearch>();
  @ViewChild('basicSearchBox', { static: true }) basicSearchBox: ElementRef;

  minLengthValidator = new FormControl('', [Validators.minLength(3)]);

  constructor(private router: Router) {}

  ngAfterViewInit() {
    fromEvent(this.basicSearchBox.nativeElement, 'keyup')
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          const newSearch: TableSearch = { field: 'search', value: this.basicSearchBox.nativeElement.value };
          this.minLengthValidator.markAsTouched();
          this.newBasicSearch.next(newSearch);
        })
      )
      .subscribe();
  }

  /**
   * Clears search when the
   */
  clearSearch() {
    this.basicSearchBox.nativeElement.value = '';
    this.minLengthValidator.markAsUntouched();
    this.newBasicSearch.next({ field: 'search', value: '' });
  }

  /**
   * Gets page name to display in the search box
   *
   * @returns the name of the current page
   */
  getSearchLabel(): string {
    if (this.searchLabel) return this.searchLabel;
    const url = this.router.url.split('?')[0];
    return 'search in ' + url.substring(url.lastIndexOf('/') + 1, url.length);
  }
}
